// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1787713423690
      var cssReload = require("/home/ubuntu/qai.sysnthesis/frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  